import { BaseApiModel } from './BaseApiModel';
import { Company } from './Company';
import { Timezone } from './Timezone';

export class Contract extends BaseApiModel {
  public code: string;
  public internalCode: string;
  public name: string;
  public regionId: string;
  public startsAt: Date;
  public endsAt: Date;
  public enabled: {
    initusTraffic: boolean;
    initus: boolean;
    omnia: boolean;
    ecs: boolean;
    bequest: boolean;
  };
  public limits: {
    spots: number;
    equipments: number;
    lanes: number;
  };
  public company: {
    id: number;
    name: string;
  };
  public speedCalculations: Array<{
    regulationId: string;
    forumula: string;
  }>;
  public prettyNames: Array<string>;
  public companies: Array<Company>;
  public companyIds: Array<string>;
  public extraData: Array<{
    title: string;
    value: string;
  }>;
  // eslint-disable-next-line no-use-before-define
  public modules: string[];
  public equipmentModelIds: any[];
  public aitTemplates: Array<{
    templateId: string;
    regulationIds: Array<string>;
  }>;
  public status: string;
  public ownerCompanyId: string;
  public createdAt: Date;
  public modifiedAt: Date;
  public timezone: Timezone;
  public enabledImportFile: boolean;
  public contractClientCodes: Array<{
    code: string;
    startsAt: string;
    endsAt: string;
  }>;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  public QRCode: {
    enabledQRCode: boolean;
    regulationIds: Array<number>;
    maxAmount: number;
  };
  public regulationIds: Array<number>;
  public ContractConfigColors: Array<{
    id: number;
    regulationId: number;
    contractId: number;
    color: string;
  }>;
  public files: Array<string>;
  public regulatorCode: string;
  public regulatorName: string;
  public regulatorAgentCode: string;
  public regulatorAgentName: string;
  public updatedAt: string;
  public decreaseImageSize: {
    allowDecrease: boolean;
    size: Array<{
      type: string;
      min: number;
      max: number;
    }>;
  };
  public modulesBequest: string[];
  public bequestUrl: string;

  get prettyName() {
    return `${this.code} - ${(this.name)}`;
  }
}

// eslint-disable-next-line no-shadow
export enum Modules {
  violations = 'violations',
  traffic = 'traffic',
  surveillance = 'surveillance',
  status = 'status',
  backup = 'backup',
  preProcess = 'preProcess',
  monitoring = 'monitoring'
}
